const initializeAnalytics = () => {
  window.analytics = window.analytics || [];
  const { analytics } = window;
  if (!analytics.initialize) {
    if (analytics.invoked) {
      // eslint-disable-next-line no-console
      console.error('Segment snippet included twice.');
      return analytics;
    }
    analytics.invoked = true;
    analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
      'addSourceMiddleware',
      'addIntegrationMiddleware',
      'setAnonymousId',
      'addDestinationMiddleware',
    ];

    analytics.factory =
      method =>
      (...args) => {
        args.unshift(method);
        analytics.push(args);
        return analytics;
      };

    for (let i = 0; i < analytics.methods.length; i += 1) {
      const key = analytics.methods[i];
      analytics[key] = analytics.factory(key);
    }

    analytics.load = (key, options) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = `https://cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`;

      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);

      analytics._loadOptions = options;
    };

    analytics.SNIPPET_VERSION = '4.13.1';

    const apiKey = process.env.REACT_APP_SEGMENT_API_KEY;

    analytics.load(apiKey, {
      integrations: {
        Mixpanel: true,
      },
    });
    analytics.page();
  }

  return analytics;
};

const analytics = initializeAnalytics();
export default analytics;
